/**
 * notify.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { SnackbarProvider } from 'notistack';
import {
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Icon from 'components/icon';

const useStyles = makeStyles((theme, alpha) => ({
  success: { backgroundColor: theme.palette.success.main },
  error: { backgroundColor: theme.palette.error.main },
  info: { backgroundColor: theme.palette.info.main },
  warning: {backgroundColor: theme.palette.warning.main },
  snackbarContainerRoot: {
    [theme.breakpoints.down('sm')]: {
    },
  },
  snackbarRoot: {
    display: 'flex',
    justifyContent: 'end',
    '& #notistack-snackbar': {
      flex: 1,
      textAlign: 'left',
    }, 
  },
  infoIcon: {
    marginRight: theme.spacing(2),
    fontSize: '1.75rem',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconButton: {
    padding: theme.spacing(1),
  },
  textButton: {
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    marginRight: theme.spacing(1),
    '&:hover': {
      border: `1px solid ${theme.palette.common.white}`,
    },
  },
  buttonText: {
    maxWidth: theme.spacing(5),
    fontSize: theme.typography.sizes[0],
    fontWeight: 700,
    textAlign: 'center',
  },
}));


export const SnackbarActionButton = (props) => {
  const {
    snackbarKey,
    onDismiss,
    dismissLabel,
    dismissVariant,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      {dismissLabel &&
        <div className={classes.buttonText}>
          {dismissLabel}
        </div>
      }
      {dismissVariant === 'text'
        ? <Button
        classes={{ root: classes.textButton }}
          key="close"
          aria-label="close"
          color="primary"
          variant="outlined"
          onClick={() => onDismiss(snackbarKey)}
        >
          DISMISS
        </Button>
        : <IconButton
        classes={{ root: classes.iconButton }}
        key="close"
        aria-label="close"
        color="inherit"
        className={classes.close}
        onClick={() => onDismiss(snackbarKey)}
        size="large">
          <CloseIcon />
        </IconButton>
      }
    </div>
  );
};

export default function NotifyProvider(props) {
  const classes = useStyles();  
  const notistackRef = React.createRef();
  const dismiss = (key) => {
    notistackRef.current.closeSnackbar(key);
  }

  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={6}
      autoHideDuration={6000}
      action={key => <SnackbarActionButton snackbarKey={key} onDismiss={dismiss} />}
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantInfo: classes.info,
        variantWarning: classes.warning,
        containerRoot: classes.snackbarContainerRoot,
        root: classes.snackbarRoot,
      }}
      iconVariant={{
        info: <Icon type='info' className={classes.infoIcon}/>,
      }}
    >
      {props.children}
    </SnackbarProvider>
  );
}